module.exports = __webpack_public_path__ + "img/instructor_fallback.10dc773b.png";